var path = 'app/scripts/modules/core/src/insight/insightLayout.component.html';
var html = "<div class=\"insight\" ng-if=\"!$ctrl.app.notFound\"\n     ng-class=\"$ctrl.insightFilterStateModel.filtersExpanded ? 'filters-expanded' : 'filters-collapsed'\">\n  <div ui-view=\"nav\" ng-if=\"!$ctrl.insightFilterStateModel.filtersHidden\" class=\"nav\"></div>\n  <div ui-view=\"master\" class=\"nav-content\" data-scroll-id=\"nav-content\"></div>\n  <div ui-view=\"detail\" class=\"detail-content\" ng-if=\"$ctrl.ready\"></div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/core/src/insight/insightLayout.component.html
// module id = 833
// module chunks = 0